import { t } from '@/plugins/i18n'
export const d2cColumns = [
  {
    label: t('商品情报'),
    prop: 'productInfo',
    align: 'center',
    slotName: 'productInfo',
    width: 80
  },
  {
    label: t('客户商品sku'),
    prop: 'itemRemark',
    align: 'center',
    slotName: 'itemRemark',
    width: 120
  },
  {
    label: t('产品规格'),
    prop: 'thirdItemAttribute',
    align: 'center',
    minWidth: 120
  },
  {
    label: t('tiktok商品状态'),
    prop: 'thirdItemStatus',
    align: 'center',
    slotName: 'thirdItemStatus',
    minWidth: 120
  },
  {
    label: t('关联状态'),
    prop: 'bindStatus',
    align: 'center',
    slotName: 'bindStatus',
    minWidth: 120
  },
  {
    label: t('已销售数量合计'),
    prop: 'sellQuantity',
    sortable: 'sellQuantity',
    align: 'center',
    minWidth: 120
  },
  {
    label: t('已发货数量合计'),
    prop: 'hasDeliverQuantity',
    align: 'center',
    minWidth: 120,
    slotName: 'hasDeliverQuantity'
  },
  {
    label: t('未发货数量合计'),
    prop: 'notDeliverQuantity',
    slotName: 'notDeliverQuantity',
    sortable: 'notDeliverQuantity',
    align: 'center',
    minWidth: 140
  },
  {
    label: t('可用库存1'),
    prop: 'waitReplenishQuantity',
    align: 'center',
    slotName: 'waitReplenishQuantity',
    sortable: 'waitReplenishQuantity',
    slotHeadName: 'waitReplenishQuantityTitle',
    className: 'gray-bg',
    minWidth: 160
  },
  {
    label: t('已锁定'),
    prop: 'freezeQuantity',
    slotName: 'freezeQuantity',
    align: 'center',
    className: 'gray-bg',
    minWidth: 120
  },
  {
    label: t('处理中合计'),
    prop: 'pendingQuantity',
    align: 'center',
    slotName: 'pendingQuantity',
    sortable: 'pendingQuantity',
    slotHeadName: 'pendingQuantityTitle',
    className: 'gray-bg pendingQuantityTitle',
    minWidth: 170
  },
  {
    label: t('处理中明细'),
    prop: 'pendingStorage',
    align: 'center',
    minWidth: 240,
    slotHeadName: 'pendingStorageHeadD2c',
    slotName: 'pendingStorageSlot',
    className: 'product-father',
    children: [
      {
        label: t('等待采购'),
        prop: 'waitPurchaseQuantity',
        slotName: 'waitPurchaseQuantity',
        align: 'center',
        // slotHeadName: 'waitPurchaseQuantityTitle',
        className: 'product-son',
        minWidth: 80
      },
      {
        label: t('采购处理中'),
        prop: 'purchasingQuantity',
        align: 'center',
        slotName: 'purchasingQuantity',
        className: 'product-son',
        minWidth: 80
      },
      {
        label: t('采购完成'),
        prop: 'purchasedQuantity',
        align: 'center',
        slotName: 'purchasedQuantity',
        className: 'product-son',
        minWidth: 80
      },
      {
        label: t('运输中'),
        prop: 'expressQuantity',
        align: 'center',
        slotName: 'expressQuantity',
        className: 'product-son',
        minWidth: 90
      },
      {
        label: t('已入库1'),
        prop: 'stockInQuantity',
        align: 'center',
        slotName: 'stockInQuantity',
        className: 'product-son',
        minWidth: 80
      },
      {
        label: t('质检中1'),
        prop: 'checkingQuantity',
        align: 'center',
        slotName: 'checkingQuantity',
        className: 'product-son',
        minWidth: 80
      },
      {
        label: t('异常处理中'),
        prop: 'abnormalQuantity',
        align: 'center',
        slotName: 'abnormalQuantity',
        className: 'product-son',
        minWidth: 80
      }
    ]
  },
  {
    label: t('历史已采购数量'),
    prop: 'historyPurchasedQuantity',
    slotName: 'historyPurchasedQuantity',
    sortable: 'historyPurchasedQuantity',
    align: 'center',
    minWidth: 160,
    className: 'gray-bg'
  },
  {
    label: t('待处理次品数'),
    prop: 'unableDefectiveQuantity',
    slotName: 'unableDefectiveQuantity',
    align: 'center',
    minWidth: 160,
    className: 'gray-bg'
  }

]

export const productTableConfig = {
  showSelection: true,
  showHandler: true,
  setHeight: true,
  rowKey: 'thirdSkuCode'
}

export const groupTableConfig = {
}

export const shopInfoDrawerColumns = [
  {
    label: t('商品情报'),
    prop: 'productInfo',
    slotName: 'productInfo',
    align: 'center'
  }, {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center'
  }, {
    label: t('THE CKB sku'),
    prop: 'productSku',
    align: 'center',
    slotName: 'productSku'

  }, {
    label: t('可用库存'),
    prop: 'availableQuantity',
    align: 'center'
  }, {
    label: t('已锁定'),
    prop: 'freezeQuantity',
    align: 'center'
  }, {
    label: t('处理中'),
    prop: 'pendingQuantity',
    align: 'center'
  }, {
    label: t('次品'),
    prop: 'unableDefectiveQuantity',
    align: 'center'
  }
]

export const combinationColumns = [
  {
    label: t('商品情报'),
    prop: 'productInfo',
    slotName: 'productInfo',
    align: 'center'
  },
  {
    label: t('客户商品规格'),
    prop: 'specification',
    align: 'center',
    slotName: 'specification',
    slotHeadName: 'specificationTitle',
    minWidth: 120,
    excludes: ['ko'],
    ununcheck: true
  },
  {
    label: t('商品规格2'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'productPropertiesName'
  },
  {
    label: t('商品SKU'),
    prop: 'productSku',
    slotName: 'productSku',
    align: 'center'
  },
  {
    label: t('单品数量'),
    prop: 'unitNums',
    align: 'center'
  },
  {
    label: t('单品落单数'),
    prop: 'remainCombinationProductItemRespList',
    align: 'center',
    slotName: 'remainCombinationProductItemRespList'
  },
  {
    label: t('单价2'),
    prop: 'productSellPrice',
    slotName: 'productSellPrice',
    align: 'center'
  }, {
    label: t('采购国家'),
    prop: 'purchaseCountry',
    align: 'center',
    slotName: 'purchaseCountry'
  }
]
